<div
  class="table-wrap"
  *ngIf="groups.length > 0; else empty"
  matSort
  matSortActive="shortRate"
  matSortDirection="desc"
  matSortDisableClear
  (matSortChange)="onSort($event)">
  <div class="row head">
    <span mat-sort-header="label" [matTooltip]="groupTooltip" matTooltipClass="session-column-tooltip">Groupe</span>
    <span mat-sort-header="chargePointCount" [matTooltip]="columnTooltips.chargePoints" matTooltipClass="session-column-tooltip">Bornes</span>
    <span mat-sort-header="sessionCount" [matTooltip]="columnTooltips.sessions" matTooltipClass="session-column-tooltip">Sessions</span>
    <span mat-sort-header="veryShortRate" [matTooltip]="columnTooltips.veryShort" matTooltipClass="session-column-tooltip">&lt; 10 s</span>
    <span mat-sort-header="shortRate" [matTooltip]="columnTooltips.short" matTooltipClass="session-column-tooltip">&lt; 60 s</span>
    <span mat-sort-header="burstRate" [matTooltip]="columnTooltips.bursts" matTooltipClass="session-column-tooltip">Rafales</span>
    <span mat-sort-header="uptimeRatio" [matTooltip]="columnTooltips.uptime" matTooltipClass="session-column-tooltip">Présence</span>
    <span mat-sort-header="medianDurationSeconds" [matTooltip]="columnTooltips.median" matTooltipClass="session-column-tooltip">Médiane</span>
    <span mat-sort-header="unstableChargePointCount" [matTooltip]="columnTooltips.unstable" matTooltipClass="session-column-tooltip">Instables</span>
  </div>
  <div class="row" *ngFor="let group of sorted">
    <span class="subject">
      <span>{{ group.label }}</span>
      <span class="meta" *ngIf="showHardware">{{ group.vendor }} · {{ group.model }} · {{ group.firmwareVersion }}</span>
    </span>
    <span>
      {{ group.stats.chargePointCount }}
      <em *ngIf="cellDelta(group.key, group.stats.chargePointCount, 'chargePointCount', 'neutral') as d" [ngClass]="d.tone">{{ d.text }}</em>
    </span>
    <span>
      {{ group.stats.sessionCount }}
      <em *ngIf="cellDelta(group.key, group.stats.sessionCount, 'sessionCount', 'neutral') as d" [ngClass]="d.tone">{{ d.text }}</em>
    </span>
    <span>
      {{ formatPercent(group.stats.veryShortRate) }}
      <em *ngIf="cellDelta(group.key, group.stats.veryShortRate, 'veryShortRate', 'lower') as d" [ngClass]="d.tone">{{ d.text }}</em>
    </span>
    <span>
      {{ formatPercent(group.stats.shortRate) }}
      <em *ngIf="cellDelta(group.key, group.stats.shortRate, 'shortRate', 'lower') as d" [ngClass]="d.tone">{{ d.text }}</em>
    </span>
    <span>
      {{ formatPercent(group.stats.burstRate) }}
      <em *ngIf="cellDelta(group.key, group.stats.burstRate, 'burstRate', 'lower') as d" [ngClass]="d.tone">{{ d.text }}</em>
    </span>
    <span>
      {{ formatPercent(group.stats.uptimeRatio) }}
      <em *ngIf="cellDelta(group.key, group.stats.uptimeRatio, 'uptimeRatio', 'higher') as d" [ngClass]="d.tone">{{ d.text }}</em>
    </span>
    <span>
      {{ formatDuration(group.stats.medianDurationSeconds) }}
      <em *ngIf="cellDelta(group.key, group.stats.medianDurationSeconds, 'medianDurationSeconds', 'higher') as d" [ngClass]="d.tone">{{ d.text }}</em>
    </span>
    <span>
      {{ group.stats.unstableChargePointCount }}
      <em *ngIf="cellDelta(group.key, group.stats.unstableChargePointCount, 'unstableChargePointCount', 'lower') as d" [ngClass]="d.tone">{{ d.text }}</em>
    </span>
  </div>
</div>
<ng-template #empty>
  <p class="empty">Aucune session sur cette fenêtre.</p>
</ng-template>
